import { ChangeEvent, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PageSizing } from '__components/Layout/PageContentWidth';
import { StyledCols } from './styles';
import { SmartConnectorContext } from '../../context';
import { FileUploader } from './FileUploader';
import Switch from '__components/Kizen/Switch';
import { SQLScripts } from './SQLScripts';
import { StyledCard, StyledLoader, StyledStepHeader } from '../styles';
import { useScripts } from '../../../hooks/useScripts';
import { SMART_CONNECTOR_STEPS } from 'pages/SmartConnectors/constants';
import { ReferenceData } from './ReferenceData';
import { WithMobileWarning } from 'pages/SmartConnectors/components/WithMobileWarning';
import { SecretsAndParameters } from './SecretsAndParameters';

export const ConnectionStep = () => {
  const { t } = useTranslation();
  const {
    isNew,
    stepData,
    setStepData,
    setIsValid,
    loading,
    setForceResetScript,
  } = useContext(SmartConnectorContext);

  const isStepValid =
    !isNew ||
    Boolean(
      stepData.source_file && (!stepData.sql_enabled || !!stepData.live_script)
    );

  useEffect(() => {
    setIsValid(isStepValid);
  }, [setIsValid, isStepValid]);

  const { handleChangeSourceFile, ...useScriptsProps } = useScripts();

  const handleToggleSQLProcessing = async (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setStepData((prev) => ({ ...prev, sql_enabled: e.target.checked }));
  };

  return (
    <WithMobileWarning>
      <PageSizing>
        <StyledCard data-qa={`${SMART_CONNECTOR_STEPS.connection}-step`}>
          <StyledStepHeader type="subheader">
            {t('Configure Connection')}
          </StyledStepHeader>
          <StyledLoader loading={loading}>
            <FileUploader onChange={handleChangeSourceFile} />
            <StyledCols columns={4} gutter="20px">
              <Switch
                onChange={handleToggleSQLProcessing}
                checked={stepData.sql_enabled || false}
                removeMargin
                label={t('Enable SQL Processing')}
                tooltip={
                  stepData.sql_required
                    ? t('The reference file provided requires SQL processing.')
                    : undefined
                }
                textPlacement="regular-top"
                disabled={stepData.sql_required}
              />
              {stepData.sql_enabled && stepData.source_file?.id ? (
                <>
                  <ReferenceData setForceResetScript={setForceResetScript} />
                  <SecretsAndParameters
                    setForceResetScript={setForceResetScript}
                  />
                </>
              ) : null}
            </StyledCols>
            {stepData.sql_enabled ? <SQLScripts {...useScriptsProps} /> : null}
          </StyledLoader>
        </StyledCard>
      </PageSizing>
    </WithMobileWarning>
  );
};
